import { Directive, Optional } from '@angular/core';
import { UntypedFormControl, NgControl } from '@angular/forms';
import { environment } from '@environments/environment';

@Directive({
  selector: '[cardValidator]',
  host: {
    '(input)': 'onInputChange($event)',
  },
})
export class CardValidatorDirective {
  constructor(@Optional() private _wrapper: NgControl) {
    if (!_wrapper) {
      return null;
    }
    this._wrapper.control.setValidators(this.cardValidator.bind(this));
  }

  cardValidator(control: UntypedFormControl): { [key: string]: boolean } {
    if (!control.value) return null;
    if (isNaN(parseInt(control.value))) return { invalidCardNumber: true };
    const engravedId = control.value.toString();
    let alternate = false;
    let sum = 0;

    for (let i = engravedId.length - 1; i >= 0; i--) {
      let n = parseInt(engravedId.substring(i, i + 1));
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      sum += n;
      alternate = !alternate;
    }
    return sum % 10 === 0 ? null : { invalidCardNumber: true };
  }

  onInputChange($event: InputEvent): void {
    (<HTMLInputElement>$event.target).value = (<HTMLInputElement>$event.target).value.replace(
      /\s/g,
      ''
    );
  }
}
